export default {
    //皮肤
    skin: 'oxide',
    resize: true,
    //插件
    plugins:['wordcount'],
    menubar:false,
    branding: false,    // 隐藏t
    //工具栏
    toolbar:['code undo redo bold italic underline link forecolor backcolor fontsize fontfamily blocks alignleft aligncenter alignright outdent indent lineheight'],
    //高度
    height: 500,
    font_family_formats: '宋体=\"宋体\"; 新宋体=\"新宋体\";仿宋=\"仿宋\"; 楷体=\"楷体\"; 黑体=\"黑体\"; 微软雅黑=\"微软雅黑\";Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Times New Roman=times new roman,times; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats',
    font_size_formats: '10px 12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 32px 34px 36px',
    font_size_input_default_unit: "px",
}